/**
 * Player Lottie enxuto — substitui o `lottie-react` (set/2026).
 *
 * Por quê: o `lottie-react` embute o `lottie-web` COMPLETO (renderers svg +
 * canvas + html + expressões, ~305 KB raw), que respondia por 17% do bundle
 * inicial porque o <Loader/> global o importa. As 5 animações do app usam um
 * único JSON (assets/load/energy.min.json), sem expressões (conferido:
 * nenhuma propriedade `"x":"..."`), então o build `lottie_light` (só SVG, sem
 * expressões) basta e tem cerca de metade do tamanho.
 *
 * Mesma assinatura que os componentes já usavam: `animationData` + `style`
 * (loop e autoplay ligados, como no default do lottie-react). Se um dia uma
 * animação precisar de expressões, trocar o import por
 * `lottie-web/build/player/lottie_svg` (SVG + expressões) — ainda menor que o
 * completo.
 */
import React, { CSSProperties, useEffect, useRef } from 'react';
import lottie, { AnimationItem } from 'lottie-web/build/player/lottie_light';

interface LottieProps {
  animationData: unknown;
  style?: CSSProperties;
  loop?: boolean;
  autoplay?: boolean;
}

const Lottie = ({
  animationData,
  style,
  loop = true,
  autoplay = true,
}: LottieProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const animation: AnimationItem = lottie.loadAnimation({
      container: containerRef.current,
      renderer: 'svg',
      loop,
      autoplay,
      animationData,
    });
    return () => animation.destroy();
  }, [animationData, loop, autoplay]);

  return <div ref={containerRef} style={style} />;
};

export default Lottie;
